.equipmentRowActions {
    align-items: center;
    display: inline-flex;
    justify-content: center;
}

.menu {
    background-color: var(--equipment-row-actions-menu-background-color);
    border-radius: var(--equipment-row-actions-menu-border-radius);
    box-shadow: var(--equipment-row-actions-menu-box-shadow);
    display: flex;
    flex-direction: column;
    min-width: var(--equipment-row-actions-menu-min-width);
    overflow: hidden;
    padding: var(--equipment-row-actions-menu-padding);
    position: fixed;
    z-index: var(--equipment-row-actions-menu-z-index);
}

.menuItem {
    color: var(--equipment-row-actions-menu-item-color);
    display: block;
    font-size: var(--equipment-row-actions-menu-item-font-size);
    padding: var(--equipment-row-actions-menu-item-padding);
    text-align: left;
    width: 100%;

    &:hover {
        background-color: var(--equipment-row-actions-menu-item-hover-background-color);
    }
}

.deleteItem {
    color: var(--equipment-row-actions-delete-color);
}

.icon {
    display: block;
    height: var(--equipment-row-actions-icon-size);
    width: var(--equipment-row-actions-icon-size);
}
